export default class MultipleAnswerValidator {
    static isAnswerCorrect(answer) {
        let expectedAnswers     = answer.correctAnswers();
        let inExpectedAnswers   = (acc,val) => acc && expectedAnswers.includes(val);
        let userInputsInExpectedAnswers = answer.userInput()
                                                .map( ui => ui.value )
                                                .reduce( inExpectedAnswers, answer.hasUserInput());
        let allAnswersSelected = answer.userInput().length === expectedAnswers.length;

        return userInputsInExpectedAnswers && allAnswersSelected;
    }
}

